import {
  createContext, useContext, useReducer, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import app from '../utils/feathers';
import { isServer } from '../utils/helpers';
import { defaultLanguage } from '../locales/i18n';

const initialState = {
  appBarTitle: '',
  appLoading: false,
  language: 'en',
  user: {
    isAuthenticated: false,
  },
};
const store = createContext('state');
const { Provider } = store;

const reducer = (state, action) => {
  switch (action.type) {
    case 'setAppBarTitle':
      return {
        ...state,
        appBarTitle: action.payload,
      };
    case 'setAppLoading':
      return {
        ...state,
        appLoading: action.payload,
      };
    case 'login': {
      const { language } = action.payload;
      window.localStorage.setItem('language', language || defaultLanguage);
      Cookie.set('language', language);
      return {
        ...state,
        user: {
          ...action.payload,
          isAuthenticated: true,
        },
        language,
      };
    }
    case 'logout':
      if (localStorage.getItem('auth')) {
        localStorage.removeItem('auth');
        try {
          app.logout();
        } catch (err) {
          console.log('logout error:', err);
        }
      }
      return {
        ...state,
        user: {
          isAuthenticated: false,
        },
      };
    default:
      throw new Error();
  }
};

const persistKey = 'app-state';

const getDefaultState = () => {
  const state = JSON.parse(localStorage.getItem(persistKey));
  if (!state) {
    return initialState;
  }
  state.appLoading = false;
  return state;
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    reducer,
    isServer
      ? initialState
      : getDefaultState(),
  );

  useEffect(() => {
    localStorage.setItem(persistKey, JSON.stringify(state));
  }, [state]);

  return (
    <Provider value={{ state, dispatch }}>
      {children}
    </Provider>
  );
};

AppProvider.defaultProps = {};
AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAppContext = () => useContext(store);
